<template>
  <main class="d-content">
    <div class="ali-base">
      <level-card />
      <act-card />
      <skill-card/>
    </div>
    <div class="ali-base">
      <time-card />
      <infos-card />
    </div>
  </main>
</template>
<script>
import LevelCard from "@/components/profile/level-card.vue";
import ActCard from "@/components/profile/activity-card.vue";
import InfosCard from "@/components/profile/infos-card.vue";
import SkillCard from "@/components/profile/skill-card.vue";
import TimeCard from "@/components/profile/time-card.vue";
export default {
  components: {
    ActCard,
    LevelCard,
    InfosCard,
    SkillCard,
    TimeCard
  },
  created (data) {
    let _params = this.$router.currentRoute.params;
    _params && _params.key && this.mStore.setKey(_params.key)
  }
};
</script>
<style>
.d-content {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px auto;
  flex-wrap: wrap;
}
.ali-base {
  align-self: baseline;
}
</style>


// WEBPACK FOOTER //
// src/pages/resume.vue